import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { LOGOS_URL } from '../../config';
import useApi from '../../hooks/useApi';
import icon from '../../assets/default.jpg';

const HomeExhibitor = ({ user, archive }) => {
    const navigate = useNavigate();
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const [ params, setParams ] = useState({ exhibitor: user._id, archived: archive });
	const [ data, error, isLoading ] = useApi({ type: 'get', method: '/eventsbyexhibitor', params });

    useEffect(() => {
        setParams({ exhibitor: user._id, archived: archive });
    }, [ user, archive ]);

	return (
    <div>
        <h1>{archive ? t('home.archive') : t('home.myevents')}</h1>
        {error && <div className='error'>{t(error)}</div>}
        {isLoading && <div>{t('common.loading')}</div>}
        {data && <React.Fragment>
            {data.events.length ?
            <React.Fragment>
                <div className='grid'>
                {data.events.map(event => (
                    <div
                        key={event._id}
                        className='item' onClick={() => navigate('/cabinet/exhibitorlistbyevent/' + event._id)}
                    >
                        <img
                            alt='icon'
                            className='icon'
                            src={event.logo ? LOGOS_URL + event.logo.base + event.logo.name : icon}
                        />
                        <div className='text'>{event.name[lang]}</div>
                    </div>
                ))}
                </div> 
            </React.Fragment> : <p>{t('home.noevents')}</p>}
        </React.Fragment>}
    </div>
	);
};

HomeExhibitor.propTypes = {
    user: PropTypes.object.isRequired,
};

export default HomeExhibitor;
